import styled from "styled-components"

export const SectionTitle = styled.h1`
  text-align: center;
  font-size: 28px;
  font-weight: bold;
  font-family: "Articulat";
`
